import moment from 'moment-timezone';
import React from 'react';

import { ReactComponent as Calendar } from '../../../assets/icons/Calendar.svg';
import { ReactComponent as PencilWrite } from '../../../assets/icons/PencilWrite.svg';
import utils from '../../../services/utils';
import Button from '../../Buttons/Button/Button';

import classes from './CardFillOutInvoiceSupplier.module.scss';

const CardFillOutInvoiceSupplier = ({ item, onDetails, onFillOut, onGoSupplier }) => {
  const { issueDate, lineExtensionAmount, supplierIsPayable } = item;

  const suppliersStyle = {
    width: '500px',
    minWidth: '500px',
    maxWidth: '500px',
    minHeight: '280px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    flexShrink: 0
  };

  return (
    <div className={`${classes.card} card-suppliers card-not-modal`} style={suppliersStyle}>
      {item.supplierName && (
        <div className={classes.head}>
          <Button title={item.supplierName} className={`text-ellipsis ${classes.name}`} onClick={onGoSupplier} custom='tertiary'>
            {item.supplierName}
          </Button>
          {!supplierIsPayable && (
            <Button Icon={PencilWrite} custom='quaternary'>
              Agregar cuenta bancaria
            </Button>
          )}
        </div>
      )}
      <span {...(item.description && { title: item.description })} className={`${classes.color} medium-16 text-ellipsis`}>
        {item.description ? item.description : 'descripción N/A'}
      </span>
      <div className={classes.calendar}>
        <Calendar />
        <span>Se emitió el {moment(issueDate).format('DD/MM/YYYY')}</span>
      </div>
      <div className={classes.totals}>
        <span className='semibold-18'>Total {utils.moneyFormat(lineExtensionAmount)}</span>
        <span className={`${classes.color} medium-12`}>*Monto sin retenciones</span>
      </div>
      <div className={classes.buttons}>
        <Button onClick={() => onFillOut(item)} custom='quaternary' Icon={PencilWrite}>
          Diligenciar
        </Button>
        <Button onClick={() => onDetails(item)} custom='quaternary'>
          Ver detalles
        </Button>
      </div>
    </div>
  );
};

export default CardFillOutInvoiceSupplier;
